"use strict";

export default angular.module("contartemx.reportes", ["ui.router", "ui.bootstrap"]).config($stateProvider => {
  $stateProvider.state("reportes", {
    url: "/Reportes",
    abstract: true,
    views: {
      submenu: {
        template: require("../../../../app/views/Reportes/Reportes_submenu.html"),
        controller: "ReportesCtrl"
      },
      "": {
        template: require("../../../../app/views/MainContainer.html"),
        controller: "ReportesCtrl"
      }
    },
    resolve: {
      authorize: [
        "authorization", authorization => authorization.authorize()
      ],
      contartemxClientes: ($q, $ocLazyLoad) => {
        return import (
        /* webpackChunkName: "reportes" */
        "./reportes").then(module => $ocLazyLoad.inject(module.default));
      }
    },
    data: {
      roles: ["Reportes"]
    }
  }).state("reportes.ganancias_perdidas", {
    url: "/Ganancias_Perdidas",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/GananciasPerdidas/GananciasPerdidas_main.html"),
        controller: "GananciasPerdidasCtrl"
      }
    },
    data: {
      roles: ["Reportes_EstadoResultados"]
    }
  }).state("reportes.estados", {
    url: "/Estados",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/Estados/Reportes_main.html"),
        controller: "ReportesMainCtrl"
      }
    },
    data: {
      roles: ["Reportes_Estados"]
    }
  }).state("reportes.generales", {
    url: "/Generales",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/Generales/Generales_main.html"),
        controller: "GeneralesMainCtrl"
      }
    },
    data: {
      roles: ["Reportes_Balanza"]
    }
  }).state("reportes.diot", {
    url: "/DIOT",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/Diot/Diot_Main.html"),
        controller: "DiotMainCtrl"
      }
    },
    data: {
      roles: ["Reportes_DIOT"]
    }
  }).state("reportes.diot2", {
    url: "/DIOT2",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/Diot/Diot2_Main.html"),
        controller: "Diot2MainCtrl"
      }
    },
    data: {
      roles: ["Reportes_DIOT"]
    }
  }).state("reportes.contabilidad", {
    url: "/ContabilidadElectronica",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/Contabilidad/ContabilidadElectronica_Main.html"),
        controller: "ContabilidadElectronicaMainCtrl"
      }
    },
    data: {
      roles: ["Reportes_ContabilidadElectronica"]
    }
  }).state("reportes.contabilidad.historial_zip", {
    url: "/HistorialZip",
    views: {
      "main@reportes": {
        template: require("../../../../app/views/Reportes/Contabilidad/HistorialZip_Main.html"),
        controller: "HistorialZipMainCtrl"
      }
    },
    data: {
      roles: ["Reportes_ContabilidadElectronica"]
    }
  }).state("reportes.bitacora", {
    url: "/Bitacora",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/Bitacora_Main.html"),
        controller: "BitacoraCtrl"
      }
    },
    data: {
      roles: ["Reportes_XmlProcesados"]
    }
  }).state("reportes.cuentas", {
    url: "/Cuentas",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/Cuentas.html"),
        controller: "ReporteCuentasCtrl"
      }
    },
    data: {
      roles: ["Reportes_Cuentas"]
    }
  }).state("reportes.no_deducibles", {
    url: "/NoDeducibles",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/NoDeducibles/Listado_NoDeducibles_Main.html"),
        controller: "ListadoNoDeduciblesCtrl"
      }
    },
    data: {
      roles: ["Reportes_NoDeducible"]
    }
  }).state("reportes.estado_cuenta", {
    url: "/EstadoCuenta/:cveCuenta",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/EstadoCuenta/Estado_Cuenta.html"),
        controller: "EstadoDeCuentaGenericoCtrl"
      }
    },
    data: {
      roles: ["Reportes"]
    }
  }).state("reportes.flujo_efectivo", {
    url: "/FlujoEfectivo",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/FlujoEfectivo/Flujo_Efectivo.html"),
        controller: "FlujoEfectivoCtrl"
      }
    },
    data: {
      roles: ["Reportes_FlujoEfectivo"]
    }
  }).state("reportes.balance", {
    url: "/Balance",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/Balance/Balance.html"),
        controller: "balanceCtrl"
      }
    },
    data: {
      roles: ["Reportes_Balance"]
    }
  })
  
  .state("reportes.mof", {
    url: "/MOF",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/ReporteMOF/reporteMOF.html"),
        controller: "reporteMOFCtrl"
      }
    },
    data: {
      roles: ["Reportes"]
    }
  })  
  .state("reportes.gpp", {
    url: "/GPP",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/ReporteGPP/reporteGPP.html"),
        controller: "reporteGPPCtrl"
      }
    },
    data: {
      roles: ["Reportes"]
    }
  })
  
  
  
  .state("reportes.flujo_por_impuestos", {
    url: "/FlujoPorImpuestos",
    views: {
      main: {
        template: require("../../../../app/views/Reportes/FlujoImpuestos/FlujoImpuestos_main.html"),
        controller: "FlujoPorImpuestosCtrl"
      }
    },
    data: {
      roles: ["Reportes"]
    }
  });
}).controller("ReportesCtrl", ($scope, $state) => {
  $scope.menuFinancieros = [];

  $scope.menuFinancieros.push({Nombre: "Balanza", Action: "../app/index.html#/Reportes/Generales"});
  $scope.menuFinancieros.push({Nombre: "Balance", Action: "../app/index.html#/Reportes/Balance"});
  $scope.menuFinancieros.push({Nombre: "Estado de Resultados", Action: "../app/index.html#/Reportes/Ganancias_Perdidas"});
  $scope.menuFinancieros.push({Nombre: "Flujo de  Efectivo", Action: "../app/index.html#/Reportes/FlujoEfectivo"});

  $scope.menuSat = [];

  $scope.menuSat.push({Nombre: "DIOT", Action: "../app/index.html#/Reportes/DIOT"});
  $scope.menuSat.push({Nombre: "DIOT 2025", Action: "../app/index.html#/Reportes/DIOT2"});
  $scope.menuSat.push({Nombre: "Contabilidad electronica", Action: "../app/index.html#/Reportes/ContabilidadElectronica"});
  $scope.menuSat.push({Nombre: "Flujo por impuestos y tasas", Action: "../app/index.html#/Reportes/FlujoPorImpuestos"});

  $scope.menuAdicionales = [];

  $scope.menuAdicionales.push({Nombre: "No deducible", Action: "../app/index.html#/Reportes/NoDeducibles"});
  $scope.menuAdicionales.push({Nombre: "XML Procesados", Action: "../app/index.html#/Reportes/Bitacora"});
  $scope.menuAdicionales.push({Nombre: "Cuentas", Action: "../app/index.html#/Reportes/Cuentas"});
  $scope.menuAdicionales.push({Nombre: "MOF", Action: "../app/index.html#/Reportes/MOF"});
  $scope.menuAdicionales.push({Nombre: "GPP", Action: "../app/index.html#/Reportes/GPP"});
});

//
